import { Alert, Anchor, Button, Group, Stack, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { Link, useRouteError } from 'react-router';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

export default function ErrorAlert() {
	const error = useRouteError();

	useEffect(() => {
		if (error) {
			Sentry.captureException(error);
		}
	}, [error]);

	const handleRefresh = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		window.location.reload();
	};

	return (
		<Alert
			icon={<IconAlertTriangle size="1.5rem" />}
			title={t('common.errors.boundaryTitle')}
			color="red"
			radius="md"
			p="lg"
		>
			<Stack gap="md">
				<Text>
					<Trans
						i18nKey="common.errors.boundaryText"
						components={[<Anchor onClick={handleRefresh} key="refresh-link" c="red" />]}
					/>
				</Text>
				<Group justify="flex-start" gap="md" mt="xs">
					<Button component={Link} to="/dashboard" color="red">
						{t('common.goToDashboard')}
					</Button>
				</Group>
			</Stack>
		</Alert>
	);
}
